import { createGoogleTagManagerMarketingMetricsDriver } from './GoogleTagManagerMarketingMetricsDriver';
import { createLocalMarketingMetricsDriver } from './LocalMarketingMetricsDriver';
import { type Country } from '~/app/auth/enums/TenantSubscriptionPlan';
import { type Locale } from '~/app/enums/Locale';

export const MARKETING_METRICS_DRIVER_NAME = {
    GOOGLE_TAG_MANAGER: 'google_tag_manager',
    LOCAL: 'local',
} as const;
export type MarketingMetricsDriverName = Enum<typeof MARKETING_METRICS_DRIVER_NAME>;

export type MarketingMetricsDriver = {
    push: <TKey extends keyof MarketingMetricsEvents>(data: MarketingMetricsEvents[TKey] & { country: Country; locale: Locale; event: TKey }) => void;
    init: () => void;
};

export const createMarketingMetricsDriver = (driver: MarketingMetricsDriverName): MarketingMetricsDriver => {
    switch (driver) {
        case MARKETING_METRICS_DRIVER_NAME.GOOGLE_TAG_MANAGER:
            return createGoogleTagManagerMarketingMetricsDriver();
        case MARKETING_METRICS_DRIVER_NAME.LOCAL:
            return createLocalMarketingMetricsDriver();
        default:
            throw new Error('Unimplemented marketing metrics driver');
    }
};
